"use strict";
exports.__esModule = true;
exports.global_palette_orange_600 = {
  "name": "--pf-v5-global--palette--orange-600",
  "value": "#773d00",
  "var": "var(--pf-v5-global--palette--orange-600)"
};
exports["default"] = exports.global_palette_orange_600;